import { useContext } from 'react';
import { ScreenSizeProvider } from './constant';

export function useScreenSize() {
  const context = useContext(ScreenSizeProvider);

  return context;
}
